/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class RecommendCount extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'RecommendCount');

    $(el).addClass('item-count-' + $(el).find('.recommend-item').length);
  }
}
